export default {
    saveCart(cart) {
        const pos = localStorage.getItem('active-pos-id');
        if (pos) localStorage.setItem(`pos-cart:${pos}`, JSON.stringify(cart));
    },
    getCart() {
        const pos = localStorage.getItem('active-pos-id');
        return JSON.parse(localStorage.getItem(`pos-cart:${pos}`));
    },
    removeCart() {
        const pos = localStorage.getItem('active-pos-id');
        localStorage.removeItem(`pos-cart:${pos}`);
    }
};
